import React from 'react';
import { useFormikContext } from 'formik';

import CardDialog from '~/components/CardDialog';
import Grid from '~/components/core/Atomic/Grid/Grid';
import Typography from '~/components/core/Atomic/Typography';
import TextFieldFormik from '~/components/TextFieldFormik';

const CLIVE_FEEDBACK_MAX_LENGTH = 5000;
const CLIVE_FEEDBACK_FIELD_ID = 'clive_feedback';
const SUBTITLE =
  'Share your feedback on how Clive drafted this FNOL — errors, inaccuracies, missing details, anything that needed correction.';

interface FnolFeedbackFormikValues {
  clive_feedback?: string;
}

export const FnolFeedback: React.FC = () => {
  const { values } = useFormikContext<FnolFeedbackFormikValues>();
  const currentLength = values.clive_feedback?.length ?? 0;

  return (
    <CardDialog title="How did Clive do?">
      <Grid container direction="column" spacing={2}>
        <Grid item xs={12}>
          <Typography display="block" variant="body2" color="textSecondary">
            {SUBTITLE}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <TextFieldFormik
            id={CLIVE_FEEDBACK_FIELD_ID}
            variant="outlined"
            multiline
            rows={3}
            fullWidth
            inputProps={{ maxLength: CLIVE_FEEDBACK_MAX_LENGTH, 'aria-label': 'Clive feedback' }}
          />
        </Grid>
        <Grid item xs={12}>
          <Typography display="block" variant="caption" color="textSecondary" align="right">
            {`${currentLength}/${CLIVE_FEEDBACK_MAX_LENGTH}`}
          </Typography>
        </Grid>
      </Grid>
    </CardDialog>
  );
};

export default FnolFeedback;
